import { graphql } from "@/gql";

export const relocationFlowReportQuery = graphql(`
  query RelocationFlowReport($year: Int!, $month: Int, $supplierId: ID) {
    relocationFlowReport(year: $year, month: $month, supplierId: $supplierId) {
      total_bookings
      cities {
        city_id
        city_name
        lat
        lng
        departure_count
        delivery_count
        median_days_to_book_departure
        median_days_to_book_delivery
      }
      movements {
        departure_city_id
        departure_city_name
        delivery_city_id
        delivery_city_name
        count
        median_days_to_book
      }
    }
  }
`);
